export const kitModel = {
  kit: function () {
    return {
      id: '',
      descricao: '',
    }
  },
}


// WEBPACK FOOTER //
// ./src/views/Kits/_model/kit.js